export enum PaymentType {
  Food,
  Transport,
  SchoolFee,
}
